import { render, staticRenderFns } from "./SmartTV.vue?vue&type=template&id=156fc044&scoped=true&"
import script from "./SmartTV.vue?vue&type=script&lang=js&"
export * from "./SmartTV.vue?vue&type=script&lang=js&"
import style0 from "./SmartTV.vue?vue&type=style&index=0&id=156fc044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156fc044",
  null
  
)

export default component.exports